import {
  atom,
  useRecoilState,
  useSetRecoilState,
} from "recoil";
const key = "dashboard-admin";

interface DashboardAdminState {
  createdAt: string;
  email: string;
  name: string;
}
const dashboardAdminState = atom<DashboardAdminState>({
  key: key,
  default: {
    createdAt: "",
    email: "",
    name: "",
  },
});
export const useDashboardAdminState = () => useRecoilState(dashboardAdminState);
export const useSetDashboardAdminState = () =>
  useSetRecoilState(dashboardAdminState);
